import { keys } from "./config";
import querystring from 'querystring'

export function buildUrl(configObject, queryObject) {
    const {env, endpoint} = configObject;

    const query = querystring.stringify(queryObject);

    return keys[env] ? `${keys[env].endpointBaseUrl}${endpoint}${query ? "?" + query : ""}` : "";
}